import React, { Component } from 'react';
import { Row, Col, Button, Card } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import { Link } from 'react-router-dom'



class BookedSuccessfully extends Component {

    render() {
        console.log(this.props)

        return (
            <div>
                <br/>
                <Row>
                    <Col md={{span: 12, offset: 6}}>
                    <Card style={{textAlign: 'center'}}>
                            <h1 style={{ color: '#52c41a' }}>
                                Booked Successfully!
                         </h1>
                            <Button size="large" type="primary">
                                <Link to="/trips-booked">
                                    See your booked trips
                                </Link>
                            </Button>
                        </Card>
                    </Col>
                </Row>

            </div>
        );
    }
}


export default BookedSuccessfully;
